<div id="address-modal">
    @if (!showMessage) {
        <div class="address-container" id="address-modal-container">
            @if (parent == 'market-checkout') {
                <div class="address-header">{{ 'addressModal.whereToDeliver' | transloco }}</div>
            } @else {
                <div class="address-header">{{ 'addressModal.confirm' | transloco }}</div>
                <div class="address-text">{{ 'addressModal.pleaseEnter' | transloco }}</div>
            }
            <input [placeholder]="'navbar.addressPlaceholder' | transloco" id="address-modal-input" radGpAutocomplete
                [options]="autocompleteOptions" class="address-input"
                (onAddressChange)="handleAddressChange($event)" />
            @if (isLoading) {
                <div class="spinner-border spinner-border-sm" role="status">
                    <span class="sr-only">{{ 'common.loading' | transloco }}</span>
                </div>
            }
            @if (addressNotFound) {
                <div class="address-delivery-message">
                    <img src="../../assets/images/icons/exclamation-mark.svg" class="message-logo">
                    {{ 'addressModal.addressNotFound' | transloco }}
                </div>
            }
            @if (missingLine1Error) {
                <div class="address-delivery-message">
                    <img src="../../assets/images/icons/exclamation-mark.svg" class="message-logo">
                    {{ 'addressModal.missingLine1Error' | transloco }}
                </div>
            }
            @if (unspecificAddressError) {
                <div class="address-delsivery-message">
                    <img src="../../assets/images/icons/exclamation-mark.svg" class="message-logo">
                    {{ 'addressModal.unspecificAddressError' | transloco }}
                </div>
            }
            @if (!addressWithinRange) {
                <div class="address-delivery-message">
                    <img src="../../assets/images/icons/exclamation-mark.svg" class="message-logo">
                    {{ 'addressModal.addressOutOfRange' | transloco }}
                </div>
            }
            @if (geolocationError) {
                <div class="address-delivery-message">
                    <img src="../../assets/images/icons/exclamation-mark.svg" class="message-logo">
                    {{ 'addressModal.geolocationError' | transloco }}
                </div>
            }
        </div>
    }
    @else {
        <app-address-confirmation [address]="address" (onSaveAddressClick)="onConfirmAddress($event)"
            (onCancelClick)="activeModal.dismiss()">
        </app-address-confirmation>
    }
</div>